/* eslint-disable no-unused-vars */
import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import AuthGuard from 'src/guards/AuthGuard';
import GuestGuard from 'src/guards/GuestGuard';
import BlankLayout from 'src/layouts/BlankLayout';
import MainLayout from 'src/layouts/main-layout';
import DashboardLayout from '../layouts/dashboard-layout';

const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};

// main pages
const Home = Loadable(lazy(() => import('../pages/Home')));

// dashboard pages
const SendGiftCard = Loadable(lazy(() => import('../pages/SendGiftCard')));
const TransactionHistory = Loadable(
  lazy(() => import('../pages/TransactionHistory'))
);
const MyAccount = Loadable(lazy(() => import('../pages/MyAccount')));

// error
const NotFound = Loadable(lazy(() => import('../pages/404')));

const Router = () => {
  return useRoutes([
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { path: 'send-gift-card', element: <SendGiftCard /> },
        { path: 'transaction-history', element: <TransactionHistory /> },
        { path: 'my-account', element: <MyAccount /> }
      ]
    },

    // Main Routes
    {
      path: '*',
      element: <BlankLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> }
      ]
    },
    {
      path: '/',
      element: (
        <GuestGuard>
          <MainLayout />
        </GuestGuard>
      ),
      children: [{ path: '/', element: <Home /> }]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
};

export default Router;
